import { categoryList } from "constants/categoriesMaster";


const initialState = {
  categoryList: {},
};

const categoriesMaster = (state = initialState, action) => {
  switch (action.type) {
    case categoryList:
      return { ...state, categoryList: action.payload };
    default:
      return state;
  }
};

export default categoriesMaster;
